module.exports = __webpack_public_path__ + "img/icon2.dd855224.png";